import axios from '@/axios';
import Steps from '@/features/registration/constants/steps';
import DistributorStatuses from '@/features/registration/constants/distributor-statuses';

/**
 * Mutations
 */
export const SET_STEP = 'SET_STEP';
export const SET_REGISTRATION_STEP = 'SET_REGISTRATION_STEP';
export const SET_DISTRIBUTOR_STATUS = 'SET_DISTRIBUTOR_STATUS';
export const SET_USER_EMAIL = 'SET_USER_EMAIL';
export const SET_DISTRIBUTOR_COMPANY = 'SET_DISTRIBUTOR_COMPANY';
export const SET_DISTRIBUTOR_ERROR = 'SET_DISTRIBUTOR_ERROR';
export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
export const RESET_STATE = 'RESET_STATE';

/**
 * Actions
 */
export const VERIFY_EMAIL = 'VERIFY_EMAIL';
export const VERIFY_COMPANY = 'VERIFY_COMPANY';
export const VERIFY_COMPANY_URL = 'VERIFY_COMPANY_URL';
export const COMPANY_EXIST = 'COMPANY_EXIST';
export const CREATE_USER = 'CREATE_USER';
export const CREATE_BOTH = 'CREATE_BOTH';

/**
 * Initial state
 */
const initialState = () => ({
  userEmail: '',
  distributorCompany: '',
  distributorStatus: DistributorStatuses.EXISTING,
  step: Steps.DISTRIBUTOR,
  distributorError: '',
  loading: false,
});

/**
 * Vuex store module state
 */
export const state = initialState();

/**
 * Vuex store module getters
 */
export const getters = {
  isStepDistributor(state) {
    return state.step === Steps.DISTRIBUTOR;
  },
  isStepRegistration(state) {
    return state.step === Steps.REGISTRATION;
  },
  isStatusNewSelected(state) {
    return state.distributorStatus === DistributorStatuses.NEW;
  },
  isStatusExistingSelected(state) {
    return state.distributorStatus === DistributorStatuses.EXISTING;
  },
  hasDistributor(state) {
    return !!state.distributorCompany;
  },
  showFormDistributorEmail(state, getters) {
    return getters.isStepDistributor && getters.isStatusExistingSelected && !!state.distributorCompany;
  },
  showFormDistributorCompany(state, getters) {
    return getters.isStepDistributor && getters.isStatusExistingSelected && !state.distributorCompany;
  },
  showDistributorStatuses(state, getters) {
    return getters.isStepDistributor && !state.distributorCompany;
  },
};

/**
 * Vuex store module actions
 */
export const actions = {
  [VERIFY_EMAIL](context, email) {
    const params = {
      email,
      company: context.state.distributorCompany,
    };
    return axios.get('/wp-json/unr/v2/user/verify_email', { params }).then(response => response.data);
  },
  [VERIFY_COMPANY](context, company) {
    const params = { company };
    return axios.get('/wp-json/unr/v2/distributor/verify_company', { params }).then(response => response.data);
  },
  [VERIFY_COMPANY_URL](context, companyURL) {
    const params = { companyURL };
    return axios.get('/wp-json/unr/v2/distributor/verify_company_url', { params }).then(response => response.data);
  },
  [COMPANY_EXIST](context, company) {
    const params = {
      company: null,
      url: null,
      ...company
    };
    return axios.get('/wp-json/unr/v2/distributor/verify_company/if_exist', { params }).then(response => response.data);
  },
  [CREATE_USER](context, {user, recaptchaToken}) {
    console.log('dss', recaptchaToken);
    const params = {
      ...user,
      recaptchaToken,
      distributorCompany: context.state.distributorCompany,
    };
    return axios.post('/wp-json/unr/v2/user', params).then(response => response.data);
  },
  [CREATE_BOTH](context, { user, distributor, recaptchaToken }) {
    return axios.post('/wp-json/unr/v2/both', { user, distributor, recaptchaToken }).then(response => response.data);
  },
};

/**
 * Vuex store module mutations
 */
export const mutations = {
  [SET_STEP](state, value) {
    state.step = value;
  },
  [SET_REGISTRATION_STEP](state, value) {
    state.step = Steps.REGISTRATION;
  },
  [SET_DISTRIBUTOR_STATUS](state, value) {
    console.log(value);
    state.distributorStatus = value;
  },
  [SET_USER_EMAIL](state, value) {
    state.userEmail = value;
  },
  [SET_DISTRIBUTOR_COMPANY](state, value = '') {
    state.distributorCompany = value;
  },
  [SET_DISTRIBUTOR_ERROR](state, value = '') {
    state.distributorError = value;
  },
  [START_LOADING](state) {
    state.loading = true;
  },
  [STOP_LOADING](state) {
    state.loading = false;
  },
  [RESET_STATE](state) {
    const initialStateInstance = initialState();
    Object.keys(initialState(initialStateInstance)).forEach(key => {
      state[key] = initialStateInstance[key];
    });
  },
};
